import React, { useState, useEffect, useContext } from "react"
import { Context } from "../../utils/context"
import { isFormValid, onGetFormData, onInitForm, onSetErrorsToForm } from "../../utils/utility"
import usaFlag from "../../assets/flags/united-states.png"
import mexicoFlag from "../../assets/flags/mexico.png"

const useRecoverPasswordModal = ({open}) => {

    const { axios, authData, setAuthData, resetAuth } = useContext(Context)

    const [loading, setLoading] = useState(false)
    const [sending, setSending] = useState(false)
    const [error, setError] = useState(null)

    const [step, setStep] = useState(1)

    const [form, setForm] = useState(JSON.parse(JSON.stringify(form_data)))

    useEffect(() => {
        if(open){
            actions.onInitModule()
        }else{
            setError(null)
            setForm(JSON.parse(JSON.stringify(form_data)))
            setLoading(false)
            setStep(1)
        }
    }, [open])

    useEffect(()=>{window.scrollTo(0,0)}, [])
    
    const actions = {
        onInitModule: async() => {
            setLoading(true)
            try {
                const _form = onInitForm(form, null)
                setForm(_form)
            } catch (error) {
                console.log('Hubo un error', error)
            }
            setLoading(false)
        },
        onChangeForm: (data) => {
            let temp = { ...form }
            const id = data.config.id
            temp[id] = { ...data }
            if(id === 'password'){
                temp.password_confirmation.value2 = data.value
                temp.password_confirmation.isValid = data.value === temp.password_confirmation.value
            }
            if(error) setError(null)
            setForm(temp)
        },
        onGoToStep:(_data) => setStep(_data),
        onRequestCode: async() => {
            if(loading) return
            const errors = isFormValid(form)
            /// Check if the form is valid
            if(errors && errors.length){
                console.log(errors)
                const new_form = onSetErrorsToForm(form, errors)
                setForm(new_form)
                return
            }

            //Extract data
            let data2send = onGetFormData(form)
            data2send.phoneNumber = `${data2send.countryCode}${data2send.phoneNumber}`
            delete data2send.countryCode
            console.log(data2send)
            setLoading(true)
            try {
                const response = await axios.post("/sms/resetCode", data2send);
                console.log(response)
                if(response.status === 200){
                    setStep(2)
                }else{
                    if(response.data === null || response.data === "" ){
                        setError('There was an error with the server')
                    }else{
                        setError(response?.data?.errors?.message ?? 'There was an error with the server')
                    }
                    
                }
                setLoading(false)
                
            } catch (e) {
                console.log('Hubo un error', e)
            }
            setLoading(false)
        },
        onResendCode: async() => {
            if(loading) return
            const errors = isFormValid(form)
            /// Check if the form is valid
            if(errors && errors.length){
                console.log(errors)
                const new_form = onSetErrorsToForm(form, errors)
                setForm(new_form)
                return
            }

            //Extract data
            let data2send = onGetFormData(form)
            data2send.phoneNumber = `${data2send.countryCode}${data2send.phoneNumber}`
            delete data2send.countryCode
            console.log(data2send)
            setSending(true)
            try {
                await axios.post("/sms/resetCode", data2send);
                setLoading(false)
                setStep(2)
            } catch (e) {
                console.log('Hubo un error', e)

                
            }
            setSending(false)
        },

        onValidateCode: async() => {
            if(loading) return
            const errors = isFormValid(form)
            /// Check if the form is valid
            if(errors && errors.length){
                console.log(errors)
                const new_form = onSetErrorsToForm(form, errors)
                setForm(new_form)
                return
            }

            //Extract data
            let data2send = onGetFormData(form)

            
            data2send.phoneNumber = `${data2send.countryCode}${data2send.phoneNumber}`
            delete data2send.countryCode
                        
            setLoading(true)
            let approved = false
            try {
                const request = await axios.post("/sms/verifyCode", data2send);
                approved = request.data.success
                //setStep(3)
            } catch (e) {
                console.log('hubo un error master')
                console.log('Hubo un error', e)
            }
            if(approved){
                setError(null)
                setStep(3)
                console.log('Puede avanzar')
            }else{
                console.log('hubo un error')
                setError('Invalid or expired code')
            }
            
            setLoading(false)
        },
        onResetPassword: async() => {
            if(loading) return
            const errors = isFormValid(form)
            /// Check if the form is valid
            if(errors && errors.length){
                console.log(errors)
                const new_form = onSetErrorsToForm(form, errors)
                setForm(new_form)
                return
            }

            //Extract data
            let data2send = onGetFormData(form)

            data2send.phoneNumber = `${data2send.countryCode}${data2send.phoneNumber}`
            delete data2send.countryCode
            delete data2send.password_confirmation
            console.log(data2send)
            setLoading(true)
            try {
                await axios.post("/user/resetPassword", data2send);
                setStep(4)
            } catch (e) {
                console.log('Hubo un error', e)
                setError('There was an error')
            }
            setLoading(false)
        },
    }



    const system = {loading, sending, error}
    const view_data = {step}

    return {system, view_data, actions, form }
}

export default useRecoverPasswordModal

const form_data = {
    email:{
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config:{
            id:'email',
            type:'email',
            fullWidth: true,
            label:'Email',
            placeholder:'Email',
            helperText:'Invalid email',
        },
        rules:{
            type:'email',
            min:1, max:254
        }
    },
    countryCode:{
        value: '1',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: true,
        options:[
            { label: "+1", value: "1", img: usaFlag},
            { label: "+52", value: "52", img: mexicoFlag},
        ],
        config:{
            id:'countryCode',
            type:'select',
            fullWidth: true,
            label:'Code',
            placeholder:'Code',
            helperText:'Invalid code number',
        },
        rules:{
            type:'select',
        }
    },
    phoneNumber:{
        value: '',
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config:{
            id:'phoneNumber',
            type:'text',
            fullWidth: true,
            label:'Mobile',
            placeholder:'Mobile',
            helperText:'Invalid mobile number',
        },
        rules:{
            type:'phone',
        }
    },
    code:{
        value: '',
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config:{
            id:'code',
            type:'number',
            fullWidth: true,
            label:'Code',
            placeholder:'Code',
        },
        rules:{
            type:'none',
            min:1, max:6
        }
    },
    password:{
        value: '',
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config:{
            id:'password',
            type:'password',
            fullWidth: true,
            label:'Password',
            placeholder:'Password',
            helperText:'Invalid Password',
        },
        rules:{
            type:'distance',
            min:1, max:256
        }
    },
    password_confirmation:{
        value: '',
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config:{
            id:'password_confirmation',
            type:'password',
            fullWidth: true,
            label:'Password confirmation',
            placeholder:'Password confirmation',
            helperText:'Passwords not match',
        },
        rules:{
            type:'equals',
            min:1, max:256
        }
    },
}
